<template>
    <div 
        class="sidebar"
        :class="{
            'sidebar_closing': !isOpen && !isSmallWindow,
            'sidebar_small': isSmallWindow
        }"
    >
        <sidebar-item
            v-for="(item, index) in sidebarItems"
            :key="index"
            :sidebarItem="item"
            :isOpen="isOpen"
            :isSmallWindow="isSmallWindow"
            :tooltipPosition="tooltipPosition"
        />
    </div>
</template>

<script>
import SidebarItem from './SidebarItem';
export default {
    name: 'Sidebar',
    components: {
        SidebarItem,
    },
    /**
     * Входные данные компонента
     * @property {array} sidebarItems - элементы сайдбара
     * @property {boolean} isOpen - режим сайдбара
     * @property {boolean} isSmallWindow - условие для свернутого сайдбара
     * @property {string} tooltipPosition - позиция подсказки
     */
    props: {
        sidebarItems: {
            type: Array,
            default: () => ([])
        },
        isOpen: {
            type: Boolean,
            default: true,
        },
        isSmallWindow: { 
            type: Boolean, 
            default: false 
        },
        tooltipPosition: { 
            type: String, 
            default: "right" 
        }
    }
}
</script>

<style lang="scss" scoped>
    .sidebar {  
        display: flex;
        flex-direction: column;
    }
    .sidebar_closing {
        margin-top: 40px;
    }
    .sidebar_small {
        flex-direction: row;
    }
</style>